import { render, staticRenderFns } from "./DesignerNotification.vue?vue&type=template&id=fc9429c0&"
import script from "./DesignerNotification.vue?vue&type=script&lang=js&"
export * from "./DesignerNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports